
import * as z from 'zod';

export const connectApiFormSchema = z.object({
  csp_account_id: z.string(),
  api_name: z.string().min(1, 'API Name is required'),
  client_id: z.string().min(1, 'Client ID is required'),
  secret_id: z.string().min(1, 'Secret Key is required'),
  trading_account_id: z.string().optional(),
  access_token: z.string().optional(),
  refresh_token: z.string().optional(),
  // Always ensure expires_in becomes a number or undefined
  expires_in: z.union([
    z.number(),
    z.string().transform((val) => {
      if (val === '') return undefined;
      const num = parseInt(val, 10);
      return isNaN(num) ? undefined : num;
    })
  ]).optional(),
  // Optional field to track an existing connection ID from OAuth flow
  connection_id: z.string().optional(),
});

export type ConnectApiFormSchema = z.infer<typeof connectApiFormSchema>;
